<template>
    <div>
      <div class="row table-row-background-color non-mobile-admin-table">
        <div style="width: 20%; margin:auto">{{ row.Name }}</div>
              <div style="width: 25%;margin:auto">
                <span class="partialEmail">{{ formattedEmail }}</span>
                <span class="fullEmail">{{ row.Email }}</span>
                </div>
           <div style="width: 20%;margin:auto">{{ formatDate(row.CreatedAt) }}</div>
                 <div style="width: 15%;margin:auto">{{ formatRole(row.RoleId) }}</div>
        <div style="width: 10%;margin:auto">
          <button
            type="button"
            class="btn btn-primary ship-selector-button"
            style="margin-bottom: 10px"
            v-on:click="details"
          >
            Edit
          </button>
        </div>
            <div style="width: 10%">
          <button
            type="button"
            class="btn btn-danger ship-selector-button"
            style="margin-bottom: 10px"
            v-on:click="deleter"
          >
            Delete
          </button>
        </div>
      </div>
  
  
  
      <div class="row table-row-background-color mobile-admin-table">
        <div style="width: 20%; margin:auto">{{ stringAbbreviation(row.Name) }}</div>
              <div style="width: 30%;margin:auto">
                <span class="partialEmail">{{ formattedEmail }}</span>
                <span class="fullEmail">{{ row.Email }}</span>
                </div>
         
                 <div style="width: 20%;margin:auto">{{ formatRole(row.RoleId) }}</div>
        <div style="width: 15%;margin:auto">
          <button
            type="button"
            class="btn btn-primary ship-selector-button"
            style="margin-bottom: 10px"
            v-on:click="details"
          >
            Edit
          </button>
        </div>
            <div style="width: 15%">
          <button
            type="button"
            class="btn btn-danger ship-selector-button"
            style="margin-bottom: 10px"
            v-on:click="deleter"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "AdministrationRow",
    props: ["row"],
    data() {
      return {
        name: "AdministrationRow",
      };
    },
    methods: {
      stringAbbreviation(str) {
        if (str.length > 5) {
          return str.substring(0, 5) + '...';
        } else {
          return str;
        }
      },
        formatRole(value){
          let roleTitle='';
  switch (value) {
    case 0:
      roleTitle = "User";
      break;
    case 1:
      roleTitle = "Administrator";
      break;
       case 2:
       roleTitle = "Super Administrator";
      break;
    default:
      roleTitle = "User";
  }
  return roleTitle;
      },
      formatDate(value){
        let dateArray = value.split("T");
  return dateArray[0]+" "+dateArray[1];
      },
      details: function () {
        this.$emit("changedSelect", this.row);
      },
          deleter: function () {
        this.$emit("deleteSelect", this.row);
      },
    },
  computed:{
  formattedEmail(){
  let emailFormatted = this.row.Email;
  let emailArray = emailFormatted.split("@");
  emailFormatted=emailArray[0]+"\n@"+emailArray[1];
  return emailFormatted;
  
  }
  }
  };
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  .fullEmail{
   display: inline;
  }
  .partialEmail{
   display: none;
  }
  @media screen and (max-width: 1000px) {
    .fullEmail {
      display: none;
    }
    .partialEmail{
   display: inline;
  }
  }
  </style>
  